import React, { useContext, useState } from "react";
import { PencilIcon } from "../../assets/ui-icons";
import { Popover, PopoverAnchor, PopoverContent } from "../ui-kit";
import GlobalSketchPicker from "./globalsketchpicker";

import ResetState from "./resetstate";
import { Tooltip } from "../input";
import { GrigoraFormatsContext } from "../formats";
import { GrigoraDashboardContext } from "../dashboard/context";
import { isCaretStartOrEnd } from "../helpers/richtext/caret-position";

var defaultColorPalette = [
  {
    title: "Black",
    value: "rgb(0, 0, 0)",
  },
  {
    title: "Yellow",
    value: "rgb(209 203 29)",
  },
  {
    title: "Purple",
    value: "rgb(157, 59, 231)",
  },
  {
    title: "Blue",
    value: "rgb(112, 149, 239)",
  },
  {
    title: "Lavender",
    value: "rgb(218, 155, 240)",
  },
  {
    title: "Green",
    value: "rgb(64 187 99)",
  },
];

var textColorPalette = [
  {
    title: "White",
    value: "rgb(255, 255, 255)",
  },
  {
    title: "Maroon",
    value: "rgb(153, 0, 17)",
  },
  {
    title: "Light Blue",
    value: "rgb(138, 170, 229)",
  },
  {
    title: "Dark Blue",
    value: "rgb(0, 83, 156)",
  },
  {
    title: "Darker Blue",
    value: "rgb(47, 60, 126)",
  },
  {
    title: "Antique White",
    value: "rgb(252, 237, 218)",
  },
];

const ColorInput = ({
  label,
  value,
  useTextColorPalette,
  onChange,
  supportSelection,
  resetValue,
}) => {
  const [openPopOver, setOpenPopOver] = useState(false);

  const { editorDocument } = useContext(GrigoraDashboardContext) ?? {};

  const {
    activeFormats,
    removeFormat,
    applyFormat,
    updateFormat,
    getFormatProps,
    getFormatElement,
  } = useContext(GrigoraFormatsContext) || {};

  const isTextSelected =
    (editorDocument?.getSelection()?.toString()?.length ?? 0) > 0;

  if (isTextSelected && activeFormats?.includes("color")) {
    value = getFormatProps("color")?.color;
  }

  var colorPalette = useTextColorPalette
    ? textColorPalette
    : defaultColorPalette;

  const handleOnChange = (e) => {
    if (isTextSelected) {
      if (supportSelection && !activeFormats?.includes("color")) {
        applyFormat("color", {
          color: e,
        });
        // onChange(e.target.value);
        return;
      } else if (supportSelection && activeFormats?.includes("color") && e) {
        // Check if selection is selecting format element or is nested
        var formatElement = getFormatElement("color");
        const { atStart, atEnd } = isCaretStartOrEnd(
          editorDocument,
          formatElement[0],
        );
        if (atStart && atEnd) {
          updateFormat("color", {
            color: e,
          });
        } else {
          applyFormat(
            "color",
            {
              color: e,
            },
            true,
          );
        }
        // onChange(e.target.value);
        return;
      } else if (!e) {
        removeFormat("color");
        return;
      }
    }

    onChange(e);
  };

  return (
    <div>
      <div className="text-grigora-base mb-1">{label}</div>
      <div className="flex w-full items-center justify-between">
        <div className="flex items-center">
          {colorPalette.map((item) => {
            return (
              <div
                onClick={(e) => {
                  if (item.value === value) {
                    handleOnChange("");
                  } else {
                    handleOnChange(item.value);
                  }
                }}
                className="w-[38px] h-[38px] p-[1px] rounded-full cursor-pointer duration-200 border-[2px] border-transparent"
                // title={item.title}
                key={`color-tile-${item.title}`}
                style={{
                  borderColor:
                    item.value === value && value === value
                      ? "rgb(114 114 114)"
                      : undefined,
                }}
              >
                <div
                  className="w-full h-full rounded-full duration-200 shadow-md hover:shadow-editor-colors-palette-hover"
                  style={{
                    backgroundColor: item.value,
                  }}
                ></div>
              </div>
            );
          })}
        </div>
        <div className="flex items-center gap-4">
          <ResetState
            active={value != resetValue}
            onClick={(e) => {
              handleOnChange(resetValue);
            }}
          />
          <Popover
            placement="left"
            open={openPopOver}
            onOpenChange={setOpenPopOver}
          >
            <PopoverAnchor>
              <Tooltip text="Edit Color" placement="left">
                <div
                  onClick={() => {
                    setOpenPopOver(true);
                  }}
                  className="editor-icon-btn cursor-pointer"
                >
                  <PencilIcon className="w-[15px] h-[15px]" />
                </div>
              </Tooltip>
            </PopoverAnchor>
            <PopoverContent className={"p-4 !rounded-[21px]"}>
              <GlobalSketchPicker
                value={value}
                onChange={handleOnChange} // return a hex rgba {object}
              />
            </PopoverContent>
          </Popover>
        </div>
      </div>
    </div>
  );
};

export default ColorInput;
